import { createRouter, createWebHistory } from 'vue-router'
import HomeView from './views/HomeView.vue'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'HomeView',
      component: HomeView,
    },
    {
      path: '/completed',
      name: 'RegistrationCompleted',
      component: () => import('./views/RegistrationCompletedView.vue'),
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'PageNotFound',
      component: async () => import('./views/PageNotFound.vue'),
      meta: {
        allowUnauthorized: true,
      },
    },
  ],
})

export default router
